import { Component, inject, InjectionToken, OnInit } from '@angular/core';
import { DynamicFormService } from '@ntap/common';
import {
  Item,
  ItemProviderDirective,
  ItemView,
  ItemViewProviderDirective,
  NtapCommonComponent,
  WindowRegistry
} from '@ntap/core';
import { tap } from 'rxjs';
import { ObrazacUnosaService } from '../fast-data-entry/service/obrazac-unosa.service';

export const FAST_OBRAZAC_TOKEN = new InjectionToken<
  ItemViewProviderDirective<ItemView>
>('fast.obrazac');

@Component({
  selector: 'app-fast-data-entry-container',
  templateUrl: './fast-data-entry-container.component.html',
  styleUrls: ['./fast-data-entry-container.component.scss'],
  providers: [
    ObrazacUnosaService,
    DynamicFormService,
    WindowRegistry,
    ItemProviderDirective,
    ItemViewProviderDirective,
    { provide: FAST_OBRAZAC_TOKEN, useExisting: ItemViewProviderDirective }
  ]
})
export class FastDataEntryContainerComponent
  extends NtapCommonComponent
  implements OnInit
{
  item: Item;
  collapsed = true;
  firstInit = true;

  private parentItemViewProvider = inject(ItemViewProviderDirective, {
    skipSelf: true
  });

  ngOnInit(): void {
    this.addSubscription(
      this.parentItemViewProvider.item$
        .pipe(
          tap((item) => {
            this.collapsed = true;
            this.item = item;
          })
        )
        .subscribe()
    );
  }
}
